class EditorialTileCarousel extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    whenReady("Swiper", () => {
      new Swiper(this.querySelector('.swiper'), {
        a11y: true,
        loop: true,
        slidesPerView: 1,
        pagination: {
          el: this.querySelector('.swiper-pagination'),
          clickable: true
        }
      });
    });
  }
}

if (!window.customElements.get('editorial-tile-carousel')) {
  customElements.define('editorial-tile-carousel', EditorialTileCarousel);
}

/**
 * On mobile (2-col grid), non-dual editorial tiles span 2 columns.
 * If one lands at column 2 (odd column position), CSS grid pushes it
 * to the next row, leaving a gap. This walks the grid tracking column
 * position — accounting for span-2 tiles consuming a full row — and
 * nudges misaligned tiles forward one slot. After each move the walk
 * restarts so subsequent tiles are evaluated against the updated order.
 */
function repositionEditorialTiles() {
  const isMobile = window.matchMedia('(max-width: 991px)').matches;

  document.querySelectorAll('.shop-grid-4').forEach(grid => {
    // Always restore original order first so we recalculate from scratch
    if (grid._editorialOriginalOrder) {
      grid._editorialOriginalOrder.forEach(el => grid.appendChild(el));
      grid._editorialOriginalOrder = null;
    }

    if (!isMobile) return;

    // Snapshot the original order before any moves
    grid._editorialOriginalOrder = Array.from(grid.children);

    // Repeatedly walk until no moves are needed
    let moved = true;
    while (moved) {
      moved = false;
      const children = Array.from(grid.children).filter(el => !el.hasAttribute('hidden'));
      let col = 0; // 0 = left column, 1 = right column

      for (const child of children) {
        const isNonDualTile = child.classList.contains('editorial-tile') &&
                              !child.classList.contains('editorial-tile--dual');

        if (isNonDualTile) {
          if (col === 1) {
            // Tile would start at col 2 — move it after its next sibling
            const next = child.nextElementSibling;
            if (next) {
              next.after(child);
              moved = true;
              break; // restart walk with updated DOM
            }
          }
          col = 0; // span-2 tile fills the row, next item starts at col 0
        } else {
          col = (col + 1) % 2;
        }
      }
    }
  });
}

const mobileQuery = window.matchMedia('(max-width: 991px)');
mobileQuery.addEventListener('change', repositionEditorialTiles);
document.addEventListener('DOMContentLoaded', repositionEditorialTiles);
document.addEventListener('filters:updated', repositionEditorialTiles);
